import { stripePromise } from "src/utils/StripePromise"
import { mutateApi } from "src/utils/api/ApiMethods"

// The server derives the SetupIntent entirely from the quote.
export const initializePaymentMethodSetup = (quoteId) => () => {
  return mutateApi({
    url: `/contract_quotes/${quoteId}/payment_methods/setup`,
    method: "POST",
  })
}

// No local row exists to tear down; an unconfirmed SetupIntent expires in Stripe.
export const cancelPaymentMethodSetup = () => Promise.resolve()

// The verify endpoint takes the payment method id, not the setup intent id.
export const createPaymentMethod =
  (quoteId) => async (setupIntentId, setupIntentClientSecret) => {
    const stripe = await stripePromise
    const { setupIntent, error } = await stripe.retrieveSetupIntent(
      setupIntentClientSecret
    )

    if (error) {
      throw error
    }

    return mutateApi({
      url: `/contract_quotes/${quoteId}/payment_methods`,
      method: "POST",
      data: { stripe_payment_method_id: setupIntent.payment_method },
    })
  }
